module.exports = __webpack_public_path__ + "resources/img/solution_game_arrow.26281336cdc023e41c6b11d32a02e80d.png";